import { Row, Col, Image } from 'react-bootstrap';
import './SLayout.css';
import vellfireImg from '../assets/vellfire.jpg';
import { isUobSbf2026Campaign } from '../campaign/uob-sbf-2026';

import { useAuthState } from '../states/auth.state';

const SLogin = () => {
  const authState = useAuthState()
  const isUobCampaignFlow = isUobSbf2026Campaign();

  if (authState.get().currentUser) {
    return <></>
  }

  if (isUobCampaignFlow) {
    return <></>
  }

  return (
    <section className="login-wrapper">
      <Row>
        {/* <Col className='mb-2 pb-4 pr-md-4'>
            <Form>
              <h5 className="title">Do you have an account with us?</h5>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label><b>USER NAME</b></Form.Label>
                <Form.Control type="text" placeholder="customer123" className="s-control" />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label><b>PASSWORD</b></Form.Label>
                <Form.Control type="password" placeholder="Password" className="s-control" />
              </Form.Group>
              <Button variant="danger" type="submit" className="px-5">
                <b>LOGIN</b>
              </Button>
              <p className="my-4">
                If you do not have an existing account and
                would like so sign up, please click <a className='link link-bright' href=""><b>here</b></a>
              </p>

              <a className='link link-bright' href="#"><b>Forgot Password</b></a>
            </Form>
          </Col> */}
        <Col className='px-0 text-center'>
          <Image src={vellfireImg} fluid className="image-fix" />
        </Col>
      </Row>
    </section>
  )
}

export default SLogin;
